import React from "react";
import { Box, CssBaseline, Toolbar, Link as MuiLink } from "@mui/material";
import { alpha } from "@mui/material/styles";
import Footer from "@components/common/Footer";

// `navWidth` é a largura que o menu lateral ocupa no desktop (260 expandido, 72
// rail, 0 oculto: o conteúdo então ocupa a tela inteira). Quem sabe o estado do
// menu é o Layout; aqui só entra o número.
const AppShell = ({ topBar, sideNav, navWidth, children }) => {
  return (
    <Box
      sx={(theme) => {
        const isDark = theme.palette.mode === "dark";
        return {
          display: { xs: "block", md: "flex" },
          minHeight: "100vh",
          position: "relative",
          backgroundColor: theme.palette.background.default,
          backgroundImage: `radial-gradient(circle at 12% 18%, ${alpha(
            theme.palette.secondary.light,
            isDark ? 0.16 : 0.2,
          )} 0%, transparent 60%), radial-gradient(circle at 88% -10%, ${alpha(
            theme.palette.primary.light,
            isDark ? 0.16 : 0.2,
          )} 0%, transparent 60%), linear-gradient(180deg, ${alpha(
            isDark ? theme.palette.common.black : theme.palette.common.white,
            isDark ? 0.55 : 0.6,
          )} 0%, transparent 65%)`,
          backgroundAttachment: "fixed",
        };
      }}
    >
      <CssBaseline />
      <MuiLink
        href="#main-content"
        sx={(theme) => ({
          position: "absolute",
          top: 8,
          left: 8,
          zIndex: theme.zIndex.modal + 1,
          px: 2,
          py: 1,
          borderRadius: 1,
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          fontWeight: 600,
          textDecoration: "none",
          transform: "translateY(-200%)",
          transition: "transform 0.2s ease",
          "&:focus, &:focus-visible": {
            transform: "translateY(0)",
            outline: `2px solid ${theme.palette.secondary.main}`,
            outlineOffset: 2,
          },
        })}
      >
        Pular para o conteudo principal
      </MuiLink>
      {topBar}
      {sideNav}

        <Box
          component="main"
          id="main-content"
          tabIndex={-1}
          sx={{
            flexGrow: 1,
            px: { xs: 2, md: 3 },
            py: { xs: 2.5, md: 4 },
            width: { md: `calc(100% - ${navWidth}px)` },
            minHeight: "100vh",
            backgroundColor: "transparent",
            display: "flex",
            flexDirection: "column",
            animation: "pageFadeUp 0.6s ease",
            "&:focus": { outline: "none" },
          }}
        >
        <Toolbar sx={{ minHeight: { xs: 64, md: 72 } }} />
        <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
          {children}
        </Box>
        <Footer />
      </Box>
    </Box>
  );
};

export default AppShell;
